import {Component, HostBinding, OnInit, ViewChild, inject} from '@angular/core';
import { FilteringLogic, IgxStringFilteringOperand, SortingDirection } from '@infragistics/igniteui-angular/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IgxExcelExporterService, IgxPdfExporterService } from '@infragistics/igniteui-angular/grids/core';
import {ClsConfig} from '../../../../util/cls-config';
import {ClsCalculoDetalleExpXConcepto} from '../../../../core/models/cls-calculo';
import {ClsUtil} from '../../../../util/cls-util';
import {GenericoService} from '../../../../core/services/generico.service';
import {AppPresupuestosService} from '../../../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../../../core/services/app-info.service';
import {EnumMasOpciones} from '../../../../core/models/enum/enum-mas-opciones';
import {ClsObjGenerico} from '../../../../clases-pu/util/cls-obj-generico';
import {FiltroGeneralComponent} from '../../controles/filtro-general/filtro-general.component';
import {VtnGenericaComponent} from '../vtn-generica/vtn-generica.component';
import {ClsConceptosPartida} from '../../../../core/models/cls-partida';
import {ClsCatalogosExpIns, ClsExpInsXConceptos} from '../../../../core/models/cls-catalogo-general';
import {
  ClsObjExplosionDeInsumos
} from '../../../../clases-pu/01-presupuesto/menu-presupuesto/cls-obj-explosion-de-insumos';
import {TranslateModule} from '@ngx-translate/core';
import {MasOpcionesGridComponent} from '../../controles/mas-opciones-grid/mas-opciones-grid.component';
import {TipoMensajesService} from "../../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../../core/pipes/summary-pipe-neo.pipe";
import { CrearComponenteDinamicoService } from '../../../../core/services/crear-componente-dinamico.service';

@Component({
  selector: 'app-exp-insumos-por-concepto',
  templateUrl: './exp-insumos-por-concepto.component.html',
  styleUrls: ['./exp-insumos-por-concepto.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    IgxIconComponent,
    FiltroGeneralComponent,
    MasOpcionesGridComponent,
    SummaryPipeNeoPipe,
  ]
})
export class ExpInsumosPorConceptoComponent extends ClsConfig implements OnInit {
  private servicioGen = inject(GenericoService);
  private infPpto = inject(AppPresupuestosService);
  private infApp = inject(AppInfoService);
  private tipoMsg = inject(TipoMensajesService);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);


  @ViewChild('gridExpInsXConcepto', {read: IgxGridComponent, static: true})
  public gridExpInsXConcepto: IgxGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralComponent, static: true})
  public filtroGeneral: FiltroGeneralComponent;

  public filaSeleccionada: ClsConceptosPartida;
  public dataExpXConcepto: ClsCalculoDetalleExpXConcepto[];
  public conceptos: ClsExpInsXConceptos[];
  public titulo: string;

  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;
  // vtn generico
  public vtnGenerico: VtnGenericaComponent;
  // OBJ
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  private mObjExpIns: ClsObjExplosionDeInsumos = new ClsObjExplosionDeInsumos();

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.conceptos = [];
  }

  public async open() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_DATOS');
      this.titulo = `${this.filaSeleccionada.Codigo}    ${this.filaSeleccionada.Descripcion}    ${this.filaSeleccionada.Unidad}`;
      this.gridExpInsXConcepto.data = [];
      this.gridExpInsXConcepto.sortingExpressions = [
        {dir: SortingDirection.Asc, fieldName: 'Tipo'},
        {dir: SortingDirection.Asc, fieldName: 'Codigo'}
      ];
      this.filtroGeneral.descripcionLabel = 'MENSAJES.GRALS.ETIQUETA_FILTRO_MATRIZ';
      this.filtroGeneral.textToolTip = 'MENSAJES.GRALS.CONTIENE';
      this.filtroGeneral.chkBuscarInicio = false;
      this.formatDecImporte = {
        digitsInfo: ClsUtil.formatoDecimales('2')
      };
      this.formatDecExpIns = {
        digitsInfo: ClsUtil.formatoDecimales('8')
      };
      const idCat: bigint = ClsUtil.esNulo(this.filaSeleccionada.IdCatalogo) ? ClsUtil.bigintX(this.filaSeleccionada.IdCatalogoS) : ClsUtil.bigintX(this.filaSeleccionada.IdCatalogo);
      this.dataExpXConcepto = await this.mObjExpIns.obtieneExpXConceptos(idCat);
      this.crearDataGrig();
      this.vtnGenerico.open(window.innerHeight - 200, window.innerWidth - 200, this.titulo, '');
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public close() {
    this.vtnGenerico.close();
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridExpInsXConcepto.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridExpInsXConcepto.filteringLogic = FilteringLogic.Or;
    this.gridExpInsXConcepto.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          this.ajustarTexto(false, this.clicked);
          break;
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridExpInsXConcepto, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.EXP_INSUMO'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridExpInsXConcepto.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridExpInsXConcepto,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.EXP_INSUMO'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  private ajustarTexto(esInit: boolean, ajustar: boolean) {
    if (esInit) {
      if (ajustar) {
        this.themesClass = 'ajustarTexto';
      } else {
        this.themesClass = 'noAjustarTexto';
      }
    } else {
      ajustar = !ajustar;
      this.clicked = !this.clicked;
      if (!ajustar) {
        this.themesClass = 'noAjustarTexto';
      } else {
        this.themesClass = 'ajustarTexto';
      }
    }
  }

  private crearDataGrig() {
    let importeConcepto1 = 0;
    let importeConcepto2 = 0;
    const mapHExpInsumos: Map<bigint, ClsCatalogosExpIns> = ClsUtil.crearMapIdCatalogo(this.infPpto.pptoActivoCompletoJSON.CatExpIns);
    this.conceptos = [];
    if (ClsUtil.esNulo(this.dataExpXConcepto)) {
      this.dataExpXConcepto = [];
    }
    importeConcepto1 = this.filaSeleccionada.Cantidad * this.filaSeleccionada.CostoMoneda1;
    importeConcepto2 = this.filaSeleccionada.Cantidad * this.filaSeleccionada.CostoMoneda2;
    this.dataExpXConcepto.forEach(value => {
      const key: bigint = ClsUtil.bigintX(value.IdCatalogo);
      const catalogo: ClsCatalogosExpIns = mapHExpInsumos.get(key);
      if (!ClsUtil.esNulo(catalogo)) {
        const concepto2: ClsExpInsXConceptos = new ClsExpInsXConceptos();
        concepto2.IdCatalogo = key;
        concepto2.Tipo = catalogo.Tipo;
        concepto2.Codigo = catalogo.Codigo;
        concepto2.DescripcionLarga = catalogo.DescripcionLarga;
        concepto2.Unidad = catalogo.Unidad;
        concepto2.Cantidad = ClsUtil.redondear(this.filaSeleccionada.Cantidad * value.Expins, 10);
        concepto2.CostoMoneda1 = catalogo.CostoMoneda1;
        concepto2.CostoMoneda2 = catalogo.CostoMoneda2;
        concepto2.ImporteMoneda1 = ClsUtil.redondearMoneda(concepto2.Cantidad * concepto2.CostoMoneda1, this.infPpto.decimalredondearimporte);
        concepto2.ImporteMoneda2 = ClsUtil.redondearMoneda(concepto2.Cantidad * concepto2.CostoMoneda2, this.infPpto.decimalredondearimporte);
        concepto2.Porcentaje1 = (importeConcepto1 > 0) ? ClsUtil.redondear(concepto2.ImporteMoneda1 / importeConcepto1, this.infPpto.decimalredondearmatrices) : 0;
        concepto2.Porcentaje2 = (importeConcepto2 > 0) ? ClsUtil.redondear(concepto2.ImporteMoneda2 / importeConcepto2, this.infPpto.decimalredondearmatrices) : 0;
        this.conceptos.push(concepto2);
      }
    });
    this.gridExpInsXConcepto.data = this.conceptos;
  }

}
